<template>
  <div>
    <div v-for="(product, product_index) in product_detail" :key="_uid+'faq'+product_index">
      <section class="section faq"
               v-if="statics_detail[product.baseProdotto.pid].schedaProdotto.faq_struttura.length"
      >
        <h2 class="vb-heading faq__heading">Domande frequenti</h2>
        <b-row class="faq__grid">
          <b-col lg="6" role="tablist"
                 v-for="(faq, faq_index) in statics_detail[product.baseProdotto.pid].schedaProdotto.faq_struttura"
                 v-bind:key="_uid+faq_index"
          >

            <accordion-block
              :heading="false"
              :title="faq.titolo"
              :collapse_id="'accordion-faq-'+_uid+'-'+faq_index"
              accordion="accordion-faq"
            >
              <p>{{ faq.descrizione }}</p>
            </accordion-block>

          </b-col>
        </b-row>
      </section>
    </div>
  </div>
</template>

<script>
import AccordionBlock from './accordion-block.vue'

export default {
  name: 'faq',

  props: {
    statics_detail: Object,
    product_detail: Array,
  },

  components: {
    'accordion-block': AccordionBlock,
  },

  data() {
    return {
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss">

  .faq {
    @extend %section_margin;

    @include media-breakpoint-up(md) {
      padding-top: $grid-gutter-20*3;
    }

    &.section {
      margin-bottom: 0;
    }

    &__heading {
      margin-bottom: $grid-gutter-20;
    }

    &__grid {
      row-gap: $grid-gutter-20;
      margin-right: -$grid-gutter-20/2;
      margin-left: -$grid-gutter-20/2;

      > [class*='col'] {
        padding-right: $grid-gutter-20/2;
        padding-left: $grid-gutter-20/2;
      }
    }
  }

</style>